import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { CentsToDollarsPipe } from '@rp/shared/pipes';
import { Observable } from 'rxjs';

import { FINANCE_WEBMASTER_PROVIDER_TOKEN, HttpFinanceWebmasterProvider } from '../../providers';
import { PayoutBalance } from '../../models';

@Component({
  selector: 'rp-my-balance',
  standalone: true,
  templateUrl: './my-balance.component.html',
  styleUrl: './my-balance.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CentsToDollarsPipe, AsyncPipe, TranslateModule],
  providers: [
    { provide: FINANCE_WEBMASTER_PROVIDER_TOKEN, useClass: HttpFinanceWebmasterProvider },
  ],
})
export class MyBalanceComponent {
  balance$: Observable<PayoutBalance>;

  private _financeWebmasterProvider = inject(FINANCE_WEBMASTER_PROVIDER_TOKEN);

  constructor() {
    this._getBalance();
  }

  private _getBalance(): void {
    this.balance$ = this._financeWebmasterProvider.getMyBalance();
  }
}
